import { AttentionType } from './globalEnums';

export const attentionMessages = {
    [AttentionType.quotaHigh_display]: 'Site size is reaching quota limit',
    [AttentionType.quotaExceeded_display]: 'Quota limit is exceeded',
    [AttentionType.ownerMissing_display]: 'Owner is missing',
    [AttentionType.expirationSoon_display]: 'Your site will expire soon',
    [AttentionType.expired_display]: 'Your site expired',
    [AttentionType.emptyOwner_display]: 'Owner is empty'
}


// WEBPACK FOOTER //
// ./src/GlobalConst/attentionMessages.js